import { createFileRoute } from '@tanstack/react-router';
import { GroupsPage } from '@/features/currency/groups-page';

export const Route = createFileRoute('/_app/settings/groups/')({
  component: GroupsPage,
});
